import { Collapse, Table, TableBody, TableCell } from "@mui/material";
import _ from "lodash";
import { useContext } from "react";

import Context from "../contextRow";
import ContextTable from "../contextTable";
import CollapseRow from "./CollapseRow";

export default function CollapseTable() {
	const { isCollapsed, positions } = useContext(Context);

	const { order, orderBy } = useContext(ContextTable);

	const orderPositions = _.orderBy(
		positions,
		orderBy === "value" ? "currentValue" : "weight",
		order
	);

	return (
		<TableCell colSpan={9} style={{ padding: 0 }}>
			<Collapse in={isCollapsed} timeout='auto' unmountOnExit>
				<Table size={"small"}>
					<TableBody>
						{orderPositions.map((row, index) => (
							<CollapseRow {...row} key={index} />
						))}
					</TableBody>
				</Table>
			</Collapse>
		</TableCell>
	);
}
